import {
  DedicatedCategory,
  DedicatedRelation,
  LoadRegistrationExpandBody,
  LoadRegistrationExpandResult,
  FrontendRegistration,
  RegistrationMode,
} from "@timeedit/registration-schemas";
import { Mapping } from "@timeedit/registration-shared";
import { createContext } from "react";
import { NavigateOptions, To } from "react-router-dom";
import {
  LoadActions,
  RegistrationProps,
  RegistrationRequiredTranslations,
  TAnalyticsEvent,
} from "./types";

type RegistrationContextType = {
  registration: FrontendRegistration;
  mode: RegistrationMode;
};

export const RegistrationContext = createContext<RegistrationContextType>(
  {} as RegistrationContextType
);

type IdContextType = {
  studentId?: number;
  id?: number;
};
export const IdContext = createContext<IdContextType>({} as IdContextType);

type AllocationControlContextType =
  RegistrationProps["allocationControlActions"];
export const AllocationControlContext =
  createContext<AllocationControlContextType>(
    {} as AllocationControlContextType
  );

type UtilContextType = {
  navigate: (to: To, options?: NavigateOptions) => void;
  translations: RegistrationRequiredTranslations;
  mapping: Mapping;
  dedicatedGroupsActions: {
    presentCategory: (data: DedicatedCategory[]) => string;
    presentRelation: (data: DedicatedRelation[]) => string;
  };
  analyticsEvent?: TAnalyticsEvent;
};
export const UtilContext = createContext<UtilContextType>(
  {} as UtilContextType
);

export const LoadActionContext = createContext<LoadActions>({
  loadRegistrationExpand: (_: LoadRegistrationExpandBody) =>
    Promise.resolve<LoadRegistrationExpandResult>({}),
});
